// extracted by mini-css-extract-plugin
export default {"portLabel":"FjGKos"};